F
<script>
  import SubmissionStatusLabel from './labels/StatusLabel'
  import ValidationMessage from '../../../components/form/ValidationMessage.vue'
  import FormSingleUpload from '../../../components/form/SingleUpload'
  import BackButton from '../../../components/general/BackButton.vue'
  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import DataService from '../../../services/dataService'
  import helperMixin from '../../../../mixins/helper'
  import {required, requiredIf, minLength, maxLength, email, url} from 'vuelidate/lib/validators'
  import {clone, orderBy} from 'lodash'
  import bus from '@utils/bus'

  export default {
    components: {SubmissionStatusLabel, ValidationMessage, FormSingleUpload, BackButton},
    mixins: [helperMixin],
    data () {
      return {
        isLoadingData: true,
        isSubmitted: false,
        expandTextarea: false,
        data: {
          authors: [],
          knowledge_area: ''
        },
        dependencies: {
          countries: [],
          knowledge_areas_level_1: [],
          knowledge_areas_level_2: [],
          knowledge_areas_level_3: [],
          knowledge_areas_level_4: []
        },
        modalEditKnowledgeAreaVisible: false,
        modalEditFieldVisible: false,
        modalEditFileVisible: false,
        modalEditAuthorVisible: false,
        knowledge_area: {
          knowledge_area_1_id: '',
          knowledge_area_2_id: '',
          knowledge_area_3_id: '',
          knowledge_area_4_id: ''
        },
        field: {
          field: {
            min_size: 0,
            max_size: 100
          },
          value: ''
        },
        file: {
          content: {},
          field: {},
          value: {
            name: '',
            size: 0,
            base64: ''
          }
        },
        author: {
          id: '',
          type: 'autor',
          primary_contact: true,
          first_name: '',
          last_name: '',
          email: '',
          orcid: '',
          country_id: '',
          biography: ''
        },
        fileSecondVersion: {
          name: '',
          size: 0,
          base64: ''
        },
        showPublishPaperVersionBox: false
      }
    },
    validations () {
      return {
        knowledge_area: {
          knowledge_area_1_id: {required},
          knowledge_area_2_id: {
            required: requiredIf(function () {
              return this.dependencies.knowledge_areas_level_2.length > 0
            })
          },
          knowledge_area_3_id: {
            required: requiredIf(function () {
              return this.dependencies.knowledge_areas_level_3.length > 0
            })
          },
          knowledge_area_4_id: {
            required: requiredIf(function () {
              return this.dependencies.knowledge_areas_level_4.length > 0
            })
          }
        },
        field: {
          value: {
            required,
            minLength: minLength(this.validationFieldMinSize),
            maxLength: maxLength(this.validationFieldMaxSize)
          }
        },
        file: {
          value: {
            base64: {required}
          }
        },
        author: {
          first_name: {required},
          last_name: {required},
          email: {required, email},
          orcid: {url},
          country_id: {required},
          biography: {required}
        }
      }
    },
    computed: {
      validationFieldMinSize: function () {
        return (this.field.field && this.field.field.min_size) || 0
      },
      validationFieldMaxSize: function () {
        return (this.field.field && this.field.field.max_size) || 100
      },
      advisors () {
        return this.data.authors.filter(item => item.author_type.key === 'orientador')
      },
      coAdvisors () {
        return this.data.authors.filter(item => item.author_type.key === 'co_orientador')
      },
      hasEditDays () {
        return this.data.event_paper_type.edit_limit_days > 0
      },
      canAddAuthor () {
        return this.hasEditDays && this.data.authors.length < this.data.event_paper_type.author_limit && this.data.can_edit_or_delete
      },
      canAddAdvisor () {
        return this.hasEditDays && this.advisors.length < this.data.event_paper_type.max_limit_advisor && this.data.can_edit_or_delete
      },
      canAddCoAdvisor () {
        return this.hasEditDays && this.coAdvisors.length < this.data.event_paper_type.max_limit_co_advisor && this.data.can_edit_or_delete
      },
      isPaperFinished () {
        return this.data.status.key === 'finalizado' ||
          this.data.status.key === 'reprovado'
      },
      isPaperDisapproved () {
        return this.data.status.key === 'reprovado'
      },
      isPaperPublished () {
        return this.data.status.key === 'aguardando_publicacao' || this.data.status.key === 'publicado'
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      bus.$emit('hide-loader')
      if (id) {
        this.getDependencies()
        this.getPaper(id)
      }
    },
    methods: {
      getDependencies () {
        DataService.get([
          {domain: 'country'}
        ]).then((result) => {
          this.dependencies = {...this.dependencies, ...result}
        })
      },
      getPaper (id) {
        restfulService.get('paper', null, id, null, [
          'event_paper_type.paper_type',
          'event_paper_type.event',
          'status',
          'registration.main_event',
          'registration.person',
          'contents.event_paper_type_field.field',
          'authors.author_type',
          'knowledge_area',
          'reviews.actions.status'
        ])
          .then(response => {
            response.authors.forEach(item => {
              item.type = item.author_type.key
            })
            response.authors = orderBy(response.authors, ['seq', 'author_type_id'], ['ASC', 'ASC'])
            response.contents = orderBy(response.contents, ['event_paper_type_field.field.type'], ['desc'])
            response.reviews = response.reviews.filter(review => {
              return (review.actions = review.actions.filter(action => {
                return action.status.key === 'avaliado' && action.notes
              })).length > 0
            })
            this.data = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch((err) => {
            console.log(err)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      },
      getKnowledgeAreas (knowledgeAreaId, level) {
        return new Promise((resolve, reject) => {
          let searchData = {
            knowledge_area_id: knowledgeAreaId,
            orderBy: [
              {
                column: 'name',
                direction: 'ASC'
              }
            ]
          }
          restfulService.search('knowledge_area', null, searchData, null, null, 1, 500)
            .then((response) => {
              if (level === 1) {
                this.dependencies.knowledge_areas_level_1 = []
                this.dependencies.knowledge_areas_level_1 = [...this.dependencies.knowledge_areas_level_1, ...response.data]
              } else if (level === 2) {
                this.dependencies.knowledge_areas_level_2 = []
                this.dependencies.knowledge_areas_level_2 = [...this.dependencies.knowledge_areas_level_2, ...response.data]
              } else if (level === 3) {
                this.dependencies.knowledge_areas_level_3 = []
                this.dependencies.knowledge_areas_level_3 = [...this.dependencies.knowledge_areas_level_3, ...response.data]
              } else {
                this.dependencies.knowledge_areas_level_4 = []
                this.dependencies.knowledge_areas_level_4 = [...this.dependencies.knowledge_areas_level_4, ...response.data]
              }
              resolve()
            })
            .catch(e => {
              reject(e)
            })
        })
      },
      changeKnowledgeArea (knowledgeAreaId, level) {
        if (level === 2) {
          this.knowledge_area.knowledge_area_2_id = ''
          this.knowledge_area.knowledge_area_3_id = ''
          this.knowledge_area.knowledge_area_4_id = ''
        } else if (level === 3) {
          this.knowledge_area.knowledge_area_3_id = ''
          this.knowledge_area.knowledge_area_4_id = ''
        } else if (level === 4) {
          this.knowledge_area.knowledge_area_4_id = ''
        }
        this.getKnowledgeAreas(knowledgeAreaId, level)
      },
      onHandleModalKnowledgeArea () {
        this.modalEditKnowledgeAreaVisible = !this.modalEditKnowledgeAreaVisible
        if (this.modalEditKnowledgeAreaVisible) {
          this.knowledge_area = {
            knowledge_area_1_id: '',
            knowledge_area_2_id: '',
            knowledge_area_3_id: '',
            knowledge_area_4_id: ''
          }
          this.changeKnowledgeArea(null, 1)
        }
      },
      onSaveKnowledgeArea () {
        bus.$emit('show-loader')
        let data = {
          knowledge_area_id: this.knowledge_area.knowledge_area_4_id || this.knowledge_area.knowledge_area_3_id || this.knowledge_area.knowledge_area_2_id || this.knowledge_area.knowledge_area_1_id
        }
        restfulService.put('paper/edit', 'save-knowledge-area', this.data.id, data)
          .then(response => {
            this.data.knowledge_area = response.knowledge_area
            this.onHandleModalKnowledgeArea()
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      onHandleModalField (content, field) {
        this.modalEditFieldVisible = !this.modalEditFieldVisible
        if (this.modalEditFieldVisible) {
          this.field.id = content.id
          this.field.value = content.value
          this.field.field = field
        }
      },
      onSaveField () {
        bus.$emit('show-loader')
        const data = clone(this.field)
        restfulService.put('paper/edit', 'field', this.data.id, data)
          .then(response => {
            let paperContent = this.data.contents.filter(item => {
              return item.id === data.id
            })
            if (paperContent.length) {
              paperContent[0].value = response.value
            }
            this.onHandleModalField()
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      onHandleModalFile (content, field) {
        this.modalEditFileVisible = !this.modalEditFileVisible
        if (this.modalEditFileVisible) {
          this.file.content = content
          this.file.field = field
          this.file.value = {
            name: '',
            size: 0,
            base64: ''
          }
        }
      },
      onRemoveFile (content) {
        this.$swal({
          title: 'Deseja realmente remover esse arquivo?',
          text: 'Essa ação não pode ser revertida!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, continuar!'
        })
          .then(() => {
            bus.$emit('show-loader')
            let data = {
              paper_content_id: content.id
            }
            restfulService.put('paper/edit', 'delete-file', this.data.id, data)
              .then(() => {
                content.value = ''
                bus.$emit('hide-loader')
              })
              .catch(e => {
                console.log(e)
                bus.$emit('hide-loader')
              })
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      onSaveFile () {
        bus.$emit('show-loader')
        let data = clone(this.file.value)
        data.paper_id = this.data.id
        data.event_paper_type_id = this.data.event_paper_type_id
        data.field_id = this.file.field.id
        data.field_name = this.file.field.name
        restfulService.put('paper/edit', 'store-file', data.paper_id, data)
          .then(response => {
            let paperContent = this.data.contents.filter(item => {
              return item.id === this.file.content.id
            })
            if (paperContent.length) {
              paperContent[0].value = response.value
            }
            this.onHandleModalFile()
            bus.$emit('hide-loader')
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      addAuthor () {
        this.onHandleModalAuthor(null, 'autor')
      },
      addAdvisor () {
        this.onHandleModalAuthor(null, 'orientador')
      },
      addCoAdvisor () {
        this.onHandleModalAuthor(null, 'co_orientador')
      },
      onHandleModalAuthor (author, type) {
        type = type || 'autor'
        this.modalEditAuthorVisible = !this.modalEditAuthorVisible
        if (this.modalEditAuthorVisible) {
          if (author) {
            this.author = author
          } else {
            this.author = {
              id: '',
              type: type,
              primary_contact: false,
              first_name: '',
              last_name: '',
              email: '',
              orcid: '',
              country_id: '',
              biography: ''
            }
          }
        }
      },
      loadAuthors () {
        bus.$emit('show-loader')
        restfulService.get('paper', null, this.$route.params.id, null, ['authors.author_type'])
          .then(response => {
            response.authors.forEach(item => {
              item.type = item.author_type.key
            })
            response.authors.sort((a, b) => a.seq - b.seq).sort((a, b) => a.author_type_id - b.author_type_id)
            this.data.authors = response.authors
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch((err) => {
            console.log(err)
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
      },
      onRemoveAuthor (author) {
        bus.$emit('show-loader')
        let data = clone(author)
        restfulService.destroy('author', null, data.id)
          .then(_ => {
            notifyService.success({hideLoader: true})
            this.loadAuthors()
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      onSaveAuthor () {
        bus.$emit('show-loader')
        let data = clone(this.author)
        data.paper_id = this.data.id
        restfulService.put('paper/edit', 'save-author', data.paper_id, data)
          .then(_ => {
            this.loadAuthors()
            this.onHandleModalAuthor()
            notifyService.success({hideLoader: true})
          })
          .catch(e => {
            console.log(e)
            bus.$emit('hide-loader')
          })
      },
      onSaveSingleFile () {
        this.isSubmitted = true
        bus.$emit('show-loader')
        let data = {
          file: clone(this.fileSecondVersion)
        }
        data.paper_id = this.data.id
        restfulService.put('paper/edit', 'single-file', data.paper_id, data)
          .then(_ => {
            this.isSubmitted = false
            this.fileSecondVersion = {
              name: '',
              size: 0,
              base64: ''
            }
            this.getPaper(data.paper_id)
            notifyService.success({hideLoader: true})
          })
          .catch(e => {
            this.isSubmitted = false
            console.log(e)
            bus.$emit('hide-loader')
          })
      }
    }
  }
</script>

<template>
    <div v-if="!isLoadingData" class="custom-list">

        <h2 class="flex-header">
            <span>Submissão #{{data.id}} / {{data.registration.main_event.title}}</span>
            <back-button/>
        </h2>
        <el-row :gutter="20" class="registration-data submission-data">
            <el-col :span="12">
                <table class="table-confirmation">
                    <thead>
                    <tr>
                        <th colspan="2">Dados da Submissão</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <strong class="field-label">Evento:</strong> {{data.event_paper_type.event.title}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong class="field-label">Tipo de Trabalho:</strong>
                            {{data.event_paper_type.paper_type.name}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div><strong class="field-label">Submetido por:</strong>
                                {{data.registration.person.pessoa.nome}}
                            </div>
                            <div><strong class="field-label">Data da Submissão:</strong> {{data.date_submitted |
                                dateTimeEnToBr}}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div><strong class="field-label">Situação:</strong>
                                <submission-status-label :status-key="data.status.key"
                                                         :status-name="data.status.public_name"/>
                            </div>
                            <div>
                                <strong class="field-label">Data da últ. atualização:</strong> {{data.last_modified |
                                dateTimeEnToBr}}
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="table-confirmation">
                    <thead>
                    <tr>
                        <th colspan="2">
                            <div class="flex-header">
                                <div>Autores</div>
                                <div>
                                    <el-button type="primary"
                                               size="mini"
                                               v-if="canAddAuthor"
                                               @click="addAuthor">
                                        <i class="fa fa-plus"></i>
                                        <span>Autor</span>
                                    </el-button>
                                    <el-button type="warning"
                                               size="mini"
                                               v-if="canAddAdvisor"
                                               @click="addAdvisor">
                                        <i class="fa fa-plus"></i>
                                        <span>Orientador</span>
                                    </el-button>
                                    <el-button type="info"
                                               size="mini"
                                               v-if="canAddCoAdvisor"
                                               @click="addCoAdvisor">
                                        <i class="fa fa-plus"></i>
                                        <span>Co-Orientador</span>
                                    </el-button>
                                </div>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="author in data.authors">
                        <td v-bind:class="{'-edit-option' : data.can_edit_or_delete}">
                            <div><strong class="field-label">{{author.author_type.name}} {{author.seq}}</strong> <span
                                    v-if="author.primary_contact"> - Contato Principal</span>
                            </div>
                            <div><strong class="field-label">Nome Completo:</strong> {{author.first_name + ' ' +
                                author.last_name}}
                            </div>
                            <div><strong class="field-label">Email:</strong> {{author.email}}</div>
                            <div class="author-actions">
                                <div class="buttons">
                                    <el-button title="Editar Autor"
                                               v-if="hasEditDays && data.can_edit_or_delete"
                                               type="info"
                                               size="small"
                                               @click="onHandleModalAuthor(author)"
                                               class="author-edit-button">
                                        <i class="fa fa-edit"></i>
                                    </el-button>
                                </div>
                                <div class="buttons">
                                    <el-button title="Remover Autor"
                                               v-if="hasEditDays && data.can_edit_or_delete"
                                               type="danger"
                                               size="small"
                                               @click="onRemoveAuthor(author)"
                                               class="author-delete-button">
                                        <i class="fa fa-trash"></i>
                                    </el-button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-col>
            <el-col :span="12">
                <table class="table-confirmation second-version-alert"
                       v-if="isPaperFinished && data.reviews.length > 0">
                    <thead>
                    <tr>
                        <th>Observações dos Avaliadores</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(review, index) in data.reviews">
                        <td>Observação {{index + 1}}: {{review.actions[0].notes}}</td>
                    </tr>
                    </tbody>
                </table>
                <table class="table-confirmation second-version-alert" v-if="isPaperFinished && !isPaperPublished && !isPaperDisapproved && showPublishPaperVersionBox">
                    <thead>
                    <tr>
                        <th>Versão para publicação do trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>
                            <el-alert type="error" show-icon :closable="false" title="">
                                <ul>
                                    <li>A versão final deve seguir estritamente o modelo disponibilizado no site do
                                        evento
                                    </li>
                                    <li>O upload do arquivo é unico e não será possível enviar outra versão</li>
                                </ul>
                            </el-alert>
                            <el-alert type="warning" show-icon :closable="false" title="">
                                <ul>
                                    <li>O arquivo deve estar no formato <strong>PDF</strong></li>
                                    <li>O tamanho máximo do arquivo deve ser de <strong>15mb</strong></li>
                                </ul>
                            </el-alert>
                            <form-single-upload :model.sync="fileSecondVersion"
                                                :max-file-size="15"
                                                accepted-types=".pdf">
                            </form-single-upload>
                            <div style="margin-top: 15px;">
                                <el-button class="submit"
                                           type="primary"
                                           @click="onSaveSingleFile"
                                           :disabled="!fileSecondVersion.base64 || isSubmitted">
                                    Enviar arquivo
                                </el-button>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="table-confirmation">
                    <thead>
                    <tr>
                        <th colspan="2">Dados do Trabalho</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="data.knowledge_area">
                        <td>
                            <strong class="field-label">Área do Conhecimento:</strong> {{data.knowledge_area.full_name}}
                            <div class="author-actions">
                                <div class="buttons">
                                    <el-button title="Editar Área do Conhecimento"
                                               v-if="hasEditDays && data.can_edit_or_delete"
                                               type="info"
                                               size="small"
                                               @click="onHandleModalKnowledgeArea"
                                               class="author-edit-button">
                                        <i class="fa fa-edit"></i>
                                    </el-button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="content in data.contents">
                        <td v-if="content.event_paper_type_field.field.type !== 'file'"
                            v-bind:class="{'-edit-option' : data.can_edit_or_delete}">
                            <el-button size="mini"
                                       @click="expandTextarea = !expandTextarea"
                                       v-if="content.event_paper_type_field.field.type === 'textarea'">
                                {{expandTextarea ? 'Reduzir' : 'Expandir'}}
                            </el-button>
                            <div v-bind:class="{'paper-content-textarea' : !expandTextarea}">
                                <div>
                                    <strong class="field-label">{{content.event_paper_type_field.field.name}}:</strong>
                                    {{content.value}}
                                </div>
                            </div>
                            <div class="author-actions">
                                <div class="buttons">
                                    <el-button :title="'Editar ' +content.event_paper_type_field.field.name"
                                               v-if="hasEditDays && data.can_edit_or_delete"
                                               type="info"
                                               size="small"
                                               @click="onHandleModalField(content, content.event_paper_type_field.field)"
                                               class="author-edit-button">
                                        <i class="fa fa-edit"></i>
                                    </el-button>
                                </div>
                            </div>
                        </td>
                        <td v-if="content.event_paper_type_field.field.type === 'file'"
                            v-bind:class="{'-missing-file': content.value === ''}"
                            class="-edit-option">
                            <span v-if="content.value && content.value !== ''">
                                <strong class="field-label">{{content.event_paper_type_field.field.name}}:</strong> {{content.value}} <span
                                    class="paper-content-file-version">(Versão: {{content.version}})</span>
                            </span>
                            <span v-if="content.value === ''">
                                <strong class="field-label"><i
                                        class="fa fa-warning"></i> Você não enviou o arquivo: </strong>Clique no botão ao lado para enviar um novo
                            </span>
                            <div class="author-actions">
                                <div class="buttons">
                                    <a :href="content.download_file_path"
                                       v-if="content.value && content.value !== ''"
                                       target="_blank"
                                       class="el-button author-edit-button el-button--info el-button--mini"
                                       title="Baixar arquivo">
                                        <i class="fa fa-download"></i>
                                    </a>
                                </div>
                                <div class="buttons"
                                     v-if="(hasEditDays && (!content.value || content.value === '' && data.can_edit_or_delete)) || (!content.value || content.value === '')">
                                    <el-button :title="'Enviar novo ' +content.event_paper_type_field.field.name"
                                               type="info"
                                               size="small"
                                               @click="onHandleModalFile(content, content.event_paper_type_field.field)"
                                               class="author-edit-button">
                                        <i class="fa fa-plus"></i>
                                    </el-button>
                                </div>
                                <div class="buttons"
                                     v-if="hasEditDays && content.value && content.value !== '' && data.can_edit_or_delete">
                                    <el-button :title="'Remover ' + content.event_paper_type_field.field.name"
                                               type="danger"
                                               size="small"
                                               @click="onRemoveFile(content)"
                                               class="author-edit-button">
                                        <i class="fa fa-trash"></i>
                                    </el-button>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-col>
        </el-row>

        <el-dialog title="Editar Área do Conhecimento"
                   v-if="modalEditKnowledgeAreaVisible"
                   :visible.sync="modalEditKnowledgeAreaVisible">
            <el-form ref="formKnowledgeArea"
                     :model="knowledge_area"
                     label-position="top">
                <el-form-item label="Grande Área"
                              v-bind:class="{
                                        'el-form-item--error': $v.knowledge_area.knowledge_area_1_id.$error,
                                        'is-required': this.dependencies.knowledge_areas_level_1.length > 0
                                      }">
                    <el-select v-model="knowledge_area.knowledge_area_1_id"
                               filterable
                               clearable
                               placeholder="Selecione uma opção"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @change="changeKnowledgeArea(knowledge_area.knowledge_area_1_id, 2)"
                               @input="$v.knowledge_area.knowledge_area_1_id.$touch()">
                        <el-option
                                v-for="item in dependencies.knowledge_areas_level_1"
                                :key="item.id"
                                :label="'(' + item.cnpq_code + ') ' + item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <validation-message v-if="$v.knowledge_area.knowledge_area_1_id.$error"/>
                </el-form-item>
                <el-form-item label="Área"
                              v-bind:class="{
                                        'el-form-item--error': $v.knowledge_area.knowledge_area_2_id.$error,
                                        'is-required': this.dependencies.knowledge_areas_level_2.length > 0 && this.knowledge_area.knowledge_area_1_id > 0
                                      }">
                    <el-select v-model="knowledge_area.knowledge_area_2_id"
                               :disabled="knowledge_area.knowledge_area_1_id === ''"
                               filterable
                               clearable
                               placeholder="Selecione uma opção"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @change="changeKnowledgeArea(knowledge_area.knowledge_area_2_id, 3)"
                               @input="$v.knowledge_area.knowledge_area_2_id.$touch()">
                        <el-option
                                v-for="item in dependencies.knowledge_areas_level_2"
                                :key="item.id"
                                :label="'(' + item.cnpq_code + ') ' + item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <validation-message v-if="$v.knowledge_area.knowledge_area_2_id.$error"/>
                </el-form-item>
                <el-form-item label="Sub-área"
                              v-bind:class="{
                                        'el-form-item--error': $v.knowledge_area.knowledge_area_3_id.$error,
                                        'is-required': this.dependencies.knowledge_areas_level_3.length !== 0 && this.knowledge_area.knowledge_area_2_id > 0
                                      }">
                    <el-select v-model="knowledge_area.knowledge_area_3_id"
                               :disabled="knowledge_area.knowledge_area_2_id === ''"
                               filterable
                               clearable
                               placeholder="Selecione uma opção"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @change="changeKnowledgeArea(knowledge_area.knowledge_area_3_id, 4)"
                               @input="$v.knowledge_area.knowledge_area_3_id.$touch()">
                        <el-option
                                v-for="item in dependencies.knowledge_areas_level_3"
                                :key="item.id"
                                :label="'(' + item.cnpq_code + ') ' + item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <validation-message v-if="$v.knowledge_area.knowledge_area_3_id.$error"/>
                </el-form-item>
                <el-form-item label="Especialidade"
                              v-bind:class="{
                                        'el-form-item--error': $v.knowledge_area.knowledge_area_4_id.$error,
                                        'is-required': this.dependencies.knowledge_areas_level_4.length !== 0 && knowledge_area.knowledge_area_3_id > 0
                                      }">
                    <el-select v-model="knowledge_area.knowledge_area_4_id"
                               :disabled="knowledge_area.knowledge_area_3_id === ''"
                               filterable
                               clearable
                               placeholder="Selecione uma opção"
                               empty-text="Nenhum registro encontrado"
                               class="el-select-full"
                               @input="$v.knowledge_area.knowledge_area_4_id.$touch()">
                        <el-option
                                v-for="item in dependencies.knowledge_areas_level_4"
                                :key="item.id"
                                :label="'(' + item.cnpq_code + ') ' + item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                    <validation-message v-if="$v.knowledge_area.knowledge_area_4_id.$error"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           @click="onSaveKnowledgeArea"
                           :disabled="$v.knowledge_area.$invalid">
                    Salvar Área do Conhecimento
                </el-button>
                <el-button @click="onHandleModalKnowledgeArea">Fechar</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="'Editar ' + field.field.name"
                   v-if="modalEditFieldVisible"
                   :visible.sync="modalEditFieldVisible">
            <el-form ref="formField"
                     :model="field"
                     label-position="top">
                <el-form-item :label="field.field.name"
                              class="is-required">
                    <el-input v-model="field.value"
                              v-if="field.field.type === 'text'"
                              :minlength="field.field.min_size"
                              :maxlength="field.field.max_size"
                              :placeholder="field.field.description">
                    </el-input>
                    <el-input v-model="field.value"
                              v-if="field.field.type === 'textarea'"
                              type="textarea"
                              :rows="6"
                              :minlength="field.field.min_size"
                              :maxlength="field.field.max_size"
                              :placeholder="field.field.description">
                    </el-input>
                    <div class="el-form-item-validation">
                        <validation-message v-if="$v.field.value.$invalid"/>
                        <span>&nbsp;</span>
                        <div class="max-length"
                             v-if="field.field.type === 'text' || field.field.type === 'textarea'">
                            Restam <span>{{field.field.max_size - field.value.length}}</span> caracteres (Mín:
                            {{field.field.min_size}} - Máx: {{field.field.max_size}})
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           @click="onSaveField"
                           :disabled="$v.field.$invalid">
                    Salvar Alterações
                </el-button>
                <el-button @click="onHandleModalField">Fechar</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Enviar Arquivo"
                   v-if="modalEditFileVisible"
                   :visible.sync="modalEditFileVisible">
            <el-form ref="formFile"
                     :model="file.value"
                     label-position="top">
                <el-form-item class="is-required">
                    <form-single-upload :model.sync="file.value"
                                        :max-file-size="file.field.max_size / 1024"
                                        accepted-types=".pdf">
                    </form-single-upload>
                    <div class="el-form-item-validation">
                        <span>&nbsp;</span>
                        <div class="max-length">
                            Tamanho máximo do arquivo <span>{{file.field.max_size / 1024}} mb</span>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           @click="onSaveFile"
                           :disabled="$v.file.value.$invalid">
                    Salvar Arquivo
                </el-button>
                <el-button @click="onHandleModalFile">Fechar</el-button>
            </div>
        </el-dialog>

        <el-dialog title="Editar Autor"
                   v-if="modalEditAuthorVisible"
                   :visible.sync="modalEditAuthorVisible">
            <el-form ref="formAuthor"
                     :model="author"
                     label-position="top">
                <h3>{{author.type === 'advisor' ? 'Orientador' : (author.type === 'coadvisor' ? 'Co-Orientador' :
                    'Autor')}}
                    <el-checkbox v-model="author.primary_contact"
                                 v-if="author.type === 'author'"
                                 label="Contato Principal">
                    </el-checkbox>
                </h3>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Primeiro Nome"
                                      class="is-required">
                            <el-input v-model="author.first_name"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Sobrenome"
                                      class="is-required">
                            <el-input v-model="author.last_name"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="E-mail"
                                      class="is-required">
                            <el-input v-model="author.email"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="ORCID iD">
                            <el-input v-model="author.orcid"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="País"
                                      class="is-required">
                            <el-select v-model="author.country_id"
                                       filterable
                                       clearable
                                       placeholder="Selecione uma Nacionalidade"
                                       empty-text="Nenhum registro encontrado"
                                       class="el-select-full">
                                <el-option
                                        v-for="item in dependencies.countries"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="Qualificação/Área de atuação/Biografia"
                              class="is-required">
                    <el-input v-model="author.biography"
                              type="textarea"
                              :rows="3"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="submit"
                           type="primary"
                           @click="onSaveAuthor"
                           :disabled="$v.author.$invalid">
                    Salvar Dados
                </el-button>
                <el-button @click="onHandleModalAuthor">Fechar</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<style lang="scss">
    .submission-data {
        td {
            position: relative;
            padding-right: 80px;
            &:hover {
                background-color: #f8f8f8;
            }
            .author-actions {
                position: absolute;
                right: 10px;
                top: 50%;
                display: table;
                margin-top: -17px;

                .buttons {
                    display: table-cell;
                    vertical-align: middle;
                    .author-edit-button,
                    .author-delete-button {
                        width: 42px;
                    }
                    padding-left: 5px;
                }
            }
            &.-missing-file {
                background-color: rgba(230, 160, 10, 0.37);
            }
        }
    }

    .second-version-alert {
        td {
            padding-right: 15px !important;
        }
        .el-alert {
            margin-bottom: 15px !important;
        }
    }

    .paper-content-textarea {
        max-height: 150px;
        overflow: auto;
    }

    .paper-content-file-version {
        display: inline-block;
        vertical-align: center;
        font-size: 12px;
        font-weight: bold;
        padding-left: 10px;
    }

</style>
